var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { curry } from "ramda";

var maxStyle = { color: "#FF595E" };

var textCount = curry(function (maxLength, text) {
  var countText = text.length + "/" + maxLength;
  var isMax = text.length >= maxLength;
  var countProps = _extends({
    children: countText
  }, isMax && { style: maxStyle });
  return {
    countText: countText,
    isMax: isMax,
    countProps: countProps
  };
});

export default textCount;